module.exports = __webpack_public_path__ + "img/capa-padrao-video.445ba584.png";